export const COMPLETE_SHARE = 'share-complete'
export const OPEN_MOBILE_APP_LINK = 'open-mobile-app-link'
